<template>
    <!--begin virtual-reality div -->
    <div id="disease-management">
        <!-- begin featured-header section -->
        <section class="featured-header">
            <div class="featured-header-bg lazyload" :data-bg="`${staticAssetPath}/img/disease-management/header-bg.png`"></div>
            <div class="featured-header-content">
                <div class="featured-tagline"><h1>Disease Management</h1></div>
                <div class="featured-subtagline"><h2>Breakdowns in the care process, comorbidities and noncompliance with treatment plans may increase the risk of high-cost, and often unnecessary, healthcare utilization.</h2></div>
            </div>
        </section>
        <!--end of featured-header section -->
        <!-- beginning of enhancing-the-care section -->
        <section class="enhancing-the-care">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Enhancing the care experience" />
                <FeaturedSubHeader featuredContent="While individuals with poorly managed health conditions and diseases typically represent a small percentage of a population, they can generate a disproportionately high percentage of healthcare costs. Accurate and timely identification of this population with targeted intervention is essential to achieving medical cost savings." />
            </div>
        </section>
        <!-- end of enhancing-the-care section -->

        <!-- beginning of identification-predictive-modeling section -->
        <section class="identification-predictive-modeling">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Identification &amp; predictive modeling" />
                <FeaturedSubHeader featuredContent="Using a combination of advanced disease algorithms and proprietary predictive risk models, we mine medical and pharmacy claims, and procedure code and eligibility data to appropriately identify individuals with primary chronic conditions: <strong>Diabetes, Coronary Artery Disease, Heart Failure, Chronic Obstructive Pulmonary Disease (COPD) and Asthma</strong>. Individuals who are currently, or are at near-term risk of, high healthcare utilization are then targeted for proactive outreach and intervention." />
            </div>
        </section>
        <!-- end of identification-predictive-modeling section -->
        <!-- beginning of numbers section -->
        <section class="numbers">
            <div class="row">
                <div class="callouts">
                    <ul>
                        <li class="callout">
                            <div class="callout-number">30+ Years</div>
                            <div class="callout-desc">Disease and Chronic Care Management Experience</div>
                        </li>
                        <li class="callout">
                            <div class="callout-number">13%</div>
                            <div class="callout-desc">Reduction in Inpatient Admissions<sup>1</sup></div>
                        </li>
                        <li class="callout">
                            <div class="callout-number">10%</div>
                            <div class="callout-desc">Reduction in Bed Days<sup>1</sup></div>
                        </li>
                        <li class="callout">
                            <div class="callout-number">$14M</div>
                            <div class="callout-desc">In Savings<sup>1</sup></div>
                        </li>
                        <li class="callout">
                            <div class="callout-number">57%</div>
                            <div class="callout-desc">Enrollment rate for those identifying for Disease Management coaching<sup>1</sup></div>
                        </li>
                        <li class="callout">
                            <div class="callout-number">Evidence-based</div>
                            <div class="callout-desc">and NCQA Accredited</div>
                        </li>
                    </ul>
                </div>
                <div class="numbers-content">Results based on multi-year program with large state government client</div>
            </div>
        </section>
        <!-- end of numbers section -->

        <!-- beginning of driving-results section -->
        <section class="driving-results">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Driving results" />
                <FeaturedSubHeader featuredContent="With more than three decades of disease and chronic care management experience, Sharecare Disease Management empowers participants to proceed on the path to better health by:" />
                <ul class="results-list">
                    <li>Identifying risks and intervening with current and future high cost individuals earlier,</li>
                    <li>Providing participants actionable education about their conditions and comorbidities,</li>
                    <li>Identifying and mitigating gaps in care,</li>
                    <li>Helping participants understand the correlation between healthy behaviors and longterm health improvement,</li>
                    <li>Tailoring recommendations to address the specific needs of a senior population, if necessary.</li>
                </ul>
            </div>
        </section>
        <!-- end of driving-results section -->

         <!-- beginning of contact-sharecare -->
        <section class="contact-sharecare">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Contact Sharecare to learn more" />
                <div class="form-container">
                    <iframe class="lazyload" title="disease-management-contact-form" :data-src="`${staticPageManagerPath}/form/disease-management-contact-form`" width="100%" height="500" type="text/html" frameborder="0" allowTransparency="true" scrolling="no" style="border: 0"></iframe>
                </div>
            </div>
        </section>
        <!-- end of contact-sharecare -->
    
    </div>
    <!-- end disease-management div -->

</template>

<script>
import '../../assets/styles/page-templates/disease-management.scss';
import DiseaseManagement from "../../assets/js/disease-management";
import H2FeaturedHeader from "../../components/H2FeaturedHeader.vue";
import FeaturedSubHeader from "../../components/FeaturedSubHeader.vue";
//import StandardCallout from "../../components/StandardCallout.vue";
//import StandardListItemCallout from "../../components/StandardListItemCallout.vue";
import 'lazysizes';

setTimeout(function() {
new DiseaseManagement(process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL);
},100)


export default {
     components: {
      H2FeaturedHeader,
      FeaturedSubHeader,
      //StandardListItemCallout,
      //StandardCallout,
    },
      data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
          staticPageManagerPath: process.env.VUE_APP_STATIC_PAGE_MANAGER_URL,
        }
      }
    }
</script>